import { Link } from 'react-router-dom';

import Pdf from "./Cats_of_Floof_and_Magic.pdf";
import classes from './ProjectList.module.css';

const RELEASED_GAMES = [
    {
        title: "Shake the Baby!",
        tags: ["Unity"],
        description:
            <div>
                <b>About the Game</b><br />
                This is a satirical boomer-shooter, focused around the idea of combining different effects to create a customizable weapon. Gameplay shifts from level traversal and exploration to fast paced arena combat and back.<br />
                <b>Development</b><br />
                There are 2 main things than I have done for this game:<br />
                1. Custom animator<br />
                Insipred by the old doom games, all of our enemies are flat sprites that are always facing the player. Each animation has a low amount of frame and 8 directions.<br />
                While Unity's animator system would allow for this, it would be too cumbersome and time consuming to set-up all of the animations, so I built a custom solution for this.
                It supports automatic direction detection, animator states, animation events and looping.<br />
                2. Level scripting<br />
                To script the dialogue and custom level events, I started coding a generic level scripting system.<br />
                That ended up being promoted to its own package, that is also showcased in the Tools section of my portfolio.<br />
                I have also contributed to the main gameplay mechanic of this game, combining babies. The system is modular and allows for any combination of babies, all of them affecting the visuals and the gameplay effects stacking on top of eachother.
            </div>,
        image: "./img/Shake the Baby/splash.jpeg",
        screenshotPath: "./img/Shake the Baby/",
        widget: <iframe src="https://store.steampowered.com/widget/3182600/" frameborder="0" width="646" height="190"></iframe>
    },
    {
        title: "The Handbook",
        tags: ["Unity"],
        description:
            <div>
                <b>About the Game</b><br />
                A medieval fantasy RPG set on an island under peculiar circumstances. You find a magical book on the ground and it falls upon you to save the small town.<br />
                A game that focuses on exploration, giving you ample rewards for finding characters and completing their quests. You follow the narrative arc to uncover more of the mysteries of the island, while constantly fighting enemies in the world by wielding an arsenal of spells.<br />
                <b>Development</b><br />
                My biggest project yet. It is a video game that started as a game for Global Game Jam 2021. The theme was "Lost and found". I had the role of a programmer and the only artist and sound manager.<br />
                Due to a missunderstanding we were only 2 people in the team, both programmers. We came up with the basic ideea for the game quickly. I thought of choosing cardboard cutouts as our arstyle since that would let me draw the art even though I do not have much exeprience in drawing.<br />
                The game jam took 5 days during which we worked day and night, getting about 4 hours of sleep everyday, just to get by. During the game jam we managed to do the dialogue system, the spells and the first area, much more than we imagined.<br />
                We overwhelmingly won the popular vote at the end of the event and after receiving positive feedback from the other participants we decided to make a fully-fledged game.<br />
                In the following months, I worked on this project along with my colleague most of the day, eventually releasing it in June of that year.<br />
                From this project, I gained experience in drawing, sprite integration and layer management, QA, sound manipulation and save/load systems. We integrated the steam interface and achievement API in the game.<br />
            </div>,
        image: "./img/The Handbook/thehandbook.jpeg",
        screenshotPath: "./img/The Handbook/",
        widget: <iframe src="https://store.steampowered.com/widget/1637520/" frameborder="0" width="646" height="190"></iframe>,
    }
]

const LONG_PROJECTS = [
    {
        title: "Cats of Floof and Magic",
        tags: ["Unity", "Online PvP"],
        description:
            <div>
                <b>About the Game</b><br />
                Thesis for my bachelor studies. A multiplayer PvP strategy game inspired by HoMM.<br />
                Players explore a cartoony hex map, build structures and recruit units to form synergistic armies. The game focuses on short, engaging turns and strategic unit compositions.<br />
                Key resources are collected to produce buildings and units, while leaders guide armies through various encounters. Encounters occur on procedurally generated battle maps, spanning multiple world turns. The primary objective is to defeat your opponent by eliminating their leaders.
            </div>,
        image: "./img/Cats/splash.jpeg",
        screenshotPath: "./img/Cats/",
        widget: <Link onClick={() => {window.open(Pdf, '_blank', 'noopener,noreferrer')}}>
            <button className={classes.button}>Open Thesis Pdf</button>
        </Link>
    },
    {
        title: "The Sip of Life",
        tags: ["Unity"],
        description:
            <div>
                <b>About the Game</b><br />
                The game is a classic, retro beat them up, side scroller. You fight groups of enemies to progress from one boss fight to another. The game offers 3 such boss encounters.<br />
                The game was based on the myth of the Iele. You play as the son of Alexander the Great looking to take revenge on the Iele for the stealing of his fathers blessed water.<br />
                You posses a group of attacks that are made to complement each other. We put great emphasis on the feeling of combat.<br />
                The twist on the theme is the synthwave visuals that we used to give a more unique and retro feel to the game. It is accompanied by old synth romanian music.<br />
                <b>Development</b><br />
                The game was made for Tales of Us Game Jam. It was a game jam based on romanian mythology. We chose the story of the Iele for our game.<br />
                I played the role of programmer, taking charge of most of the game mechanics and a lot of the design. I also had the responsability of integrating the work of our 2D artist and tech artist with the rest of the game.<br />
                One new thing I am glad I got experience in is doing state driven boss fights.<br />
                The scope turned out to be pretty large for a game jam, but we managed to get the game done and add as much polish as possible.<br />
                We worked on the game for a couple more days after to polish it further and be able to release it on itch.<br />
            </div>,
        image: "./img/The Sip of Life/splash.jpeg",
        screenshotPath: "./img/The Sip of Life/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1728415?bg_color=1c1c1c&amp;fg_color=00e45f&amp;link_color=88e7f6&amp;border_color=258484" width="552" height="167"><a href="https://zeyt8.itch.io/the-sip-of-life">The Sip of Life by Zeyt8, TheDarkVoice, blueTimber</a></iframe>,
    }
]

const GAME_JAMS = [
    {
        title: "Recruitment Hell",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2026</b><br />
                <b>About the Game</b><br />
                You play as the head recruiter of a large company. You are tasked with screening CVs and conducting interviews to hire people.<br />
                Unfortunately for you, alongside real human applicants there are demons masked as humans trying to get in. The game is inspired by "Papers Please", but with you playing just one part of the process.<br />
                You can hire people in your HR team to help with the work. Behind the scenes, there is also a power struggle between the different demon factions trying to take control of your company and events happen from day to day to reflect this.<br />
                <b>Development</b><br />
                I have worked mainly on the procedural generation of the game's characters. That is creating the backend logic for generating character traits and descriptions, their CVs and interactions and graphics<br />
                By doing this I have also coordinated with the artist to create the necessary parts for the character graphic generation.<br />
                On top of this, I was also in charge of audio and involved in the design of the game and UI.
            </div>,
        image: "./img/RecruitmentHell/1.jpeg",
        screenshotPath: "./img/RecruitmentHell/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/4249682?linkback=true&amp;bg_color=000000&amp;fg_color=f70000&amp;link_color=f70000&amp;border_color=720606" width="552" height="167"><a href="https://zeyt8.itch.io/recruitment-hell">Recruitment Hell by Zeyt8</a></iframe>
    },
    {
        title: "I am (noun)",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2025</b><br />
                <b>About the Game</b><br />
                A puzzle game where you can switch speech bubbles around characters or even change the words inside them.<br />
                The characters will react according to the words they see in the bubbles. Any allowed combination of words will trigger a different outcome.<br />
                <b>Development</b><br />
                My contribution started with contributing to the design the main level of the game and the tutorial.<br />
                After that came the most challenging part, creating a system that would easily allow us to script all of the different interactions between the characters and the bubbles.<br />
                In the end I managed to create a generic enough system that allowed us to easily change the character's behaviour and even impact other characters.<br />
            </div>,
        image: "./img/I am noun/1.jpeg",
        screenshotPath: "./img/I am noun/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/3272614?linkback=true" width="552" height="167"><a href="https://zeyt8.itch.io/bubbles">I am (noun) by Zeyt8, TheDarkVoice, TheGreatJoebama, blueTimber</a></iframe>
    },
    {
        title: "DON'T SHAKE THE BABIES (GGJ)",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2024</b><br />
                <b>About the Game</b><br />
                An ironic/humorous first person shooter where you have to combine babies into a bigger baby, shake them to trigger their fuse and throw them at enemies/walls.<br />
                <b>Development</b><br />
                Most of the time has been spent on the baby types. We developed a system where you can easily program new baby modules and combine them.<br />
                I made the character controller, most of the VFX of the babies and the general high level system of the game.
            </div>,
        image: "./img/DontShakeTheBabies/1.jpeg",
        screenshotPath: "./img/DontShakeTheBabies/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/2496630" width="552" height="167"><a href="https://zeyt8.itch.io/dont-shake-the-babies">Don't shake the babies by Zeyt8, blueTimber, TheDarkVoice</a></iframe>
    },
    {
        title: "Only 2% of People Can Finish This?!",
        tags: ["Unity"],
        description:
            <div>
                <b>Thinky Puzzle Game Jam 3</b><br />
                <b>About the Game</b><br />
                Embark on a mind-bending adventure that will put your intellectual prowess to the test, while immersing yourself in a world of uproarious comedy, in this captivating and exhilarating puzzler!<br />
                With five distinct and intricately designed levels awaiting your exploration, each one packed with its own ingenious puzzles, this game promises an experience like no other.<br />
                From unraveling mind-bending riddles to navigating through a maze of perplexing conundrums, every level presents a unique challenge that demands your utmost attention and problem-solving skills.<br />
                As you progress through this comedic journey, you'll not only exercise your intellect but also find yourself captivated by the unfolding narrative.<br />
                So, ready your wits, don your thinking cap, and get ready to embark on an unforgettable adventure brimming with laughter, discovery, and mind-boggling challenges.<br />
                Can you conquer each level and unravel the enigma that binds this comedic puzzler? The stage is set, and the narrator eagerly awaits your arrival.<br />
                <b>Development</b><br />
                On the programming side, me and the other programmer split the levels between us.
                I made levels 1, 3 and 5 and also the base mechanics of the game that were used in all levels.<br />
                I can also say I did some problem solving regarding IKs. We had a lot of components that had to be moved with the mouse during the levels and main menu and I had to make sure they were always in the right place.<br />
                The other thing I did was materials. It was the first time we used realistic PBR materials in a game jam and I really focused on them. I did learn a lot about the process and how everyting works.<br />
            </div>,
        image: "./img/Only2Percent/6.jpeg",
        screenshotPath: "./img/Only2Percent/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/2142308?bg_color=2f2f2f&amp;fg_color=ffffff&amp;link_color=fa5c5c&amp;border_color=28da1d" width="552" height="167"><a href="https://zeyt8.itch.io/chalk-and-cheese">Only 2% of People Can Finish This?! by Zeyt8, blueTimber, Andrei Tache, TheDarkVoice</a></iframe>,
    },
    {
        title: "Root Rot",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2023</b><br />
                <b>About the Game</b><br />
                You are a bush that has the ability to shoot and control roots. You can use these roots to grab onto objects and move yourself or the objects.<br />
                The game is full of enemies, platforms and hazards that you can use.<br />
                The game plays like a hack and slash action game. You are very powerful and enemies die easily.<br />
                The game is meant to be played in a fast paced manner, grabbing onto enemies and throwing them around constantly.<br />
                Almost everything in the game is interactable, so use the environment to your advantage.<br />
                <b>Development</b><br />
                This project was part of the event "Global Game Jam 2023". We had 48 hours to create a game with the theme "Roots".<br />
                I was in charge of many things in this project. As a programmer, I worked on programming the level mechanics and the game's general framework and integrating movement and AI with the other stuff.<br />
                I managed materials, shaders, audio and general polishing. I also worked on the level design.<br />
                The great focus of this game jam was on polish and I am glad that we managed to achieve that.<br />
                We spent time on adding small details, like a lot of animations, particle effects etc. and making the game feel good to play.<br />
                Code wise, we put emphasis on separating systems and making them as modular as possible. All of our prefabs have almost no dependencies and work by themselves.<br />
                This allowed us to add new features and mechanics very easily and we ran into almost no bugs once we put everything together.<br />
                The experience was great and I am delighted that I was part of this project.
            </div>,
        image: "./img/Root Rot/1.jpeg",
        screenshotPath: "./img/Root Rot/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1910343?bg_color=e9d996&amp;fg_color=282828&amp;link_color=af060f&amp;border_color=b84d4d" width="552" height="167"><a href="https://zeyt8.itch.io/root-rot">Root Rot by Zeyt8, blueTimber</a></iframe>,
    },
    {
        title: "Snails in Peril",
        tags: ["UE4"],
        description:
            <div>
                <b>Week Sauce (Apr 2022)</b><br />
                <b>About the Game</b><br />
                You have to go through a series of levels while controlling 2 snails with different abilities.<br />
                The snails work together to evade the evil snails who want them captured and to unlock the path forward.<br />
                Stealth and subtilty is the key element here as evil snails are way too powerfull to be taken up front.<br />
                Puzzles will be challenging the cooperation between the snails.<br />
                <b>Development</b><br />
                This project was part of the event "Week Sauce (Apr 2022)". The theme was the name of a band of our own
                choosing, ours being Snail. I was the programmer of the team.<br />
                We had any 7 days, not necessarily consecutive days in the month of april to make the game. Due to our busy
                schedule, we only used 3 of those days. One month after the jam we worked on the game for another 3 days. We
                redid the entire design and implemeted the remaining ideas we had.<br />
                Within this project I handled the general direction of the game. As the only programmer I took part in all
                of the development pipeline of the game. My work ranged from player controlls to AI behaviour using state
                machines to procedural meshes and animation.<br />
                I was in charge of the level design of the reworked level we made after the jam.
            </div>,
        image: "./img/Snailz/8.jpeg",
        screenshotPath: "./img/Snailz/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1510265?bg_color=346c30&amp;fg_color=98e081&amp;link_color=98e081&amp;border_color=4c4877" width="552" height="167"><a href="https://zeyt8.itch.io/snails-in-peril">Snails in Peril by Zeyt8, TheDarkVoice, blueTimber</a></iframe>,
    },
    {
        title: "Privacy",
        tags: ["Unity"],
        description:
            <div>
                <b>Jam de casă</b><br />
                <b>About the Game</b><br />
                You play as a 36 year old hacker. Your task is to infiltrate your target's computer and collect information
                based on the task on hand.<br />
                Tasks range from copying files to your USB stick to learning information about your target about which you will
                be intoregated.<br />
                You navigate on a computer, through its folders, looking through the files. Your time is limited though, so you
                have to be fast.<br />
                <b>Development</b><br />
                This project was part of the event "Jam de casă". We had 1 week to make a game based on the theme "You only
                have 5 minutes". The staff of the event played these games on a stream and all donations were donated to
                COVID19 help.<br />
                We made a computer based on Manjaro that you can navigate through to find files and clues. I was in charge
                of most of the programming. In that week, I recreated the linux interface, directory system, photo viewer
                and audio player inside the game. I also took care of the level creation and asset integration.
            </div>,
        image: "./img/Privacy/1.jpeg",
        screenshotPath: "./img/Privacy/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/757885?bg_color=141414&amp;fg_color=149414&amp;link_color=649568&amp;border_color=434343" width="552" height="167"><a href="https://zeyt8.itch.io/privacy">Privacy by Zeyt8, edemerzel, TheDarkVoice</a></iframe>,
    },
    {
        title: "Module Wreck",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2020</b><br />
                <b>About the Game</b><br />
                You're on a mission in space. Your ship is a cheap wreck.<br />
                To reach the end of the level team up with your partner in fighting enemies while repairing the modules of
                your ship that keep malfunctioning. Good luck!<br />
                <b>Development</b><br />
                This project was part of the event "Global Game Jam 2020". The theme was "Repair". I was one of the 2
                programmers.<br />
                This was the second time I attended Global Game Jam. With the experience from last time everything worked
                smoother. It took us a while to converge on the final design, but after that the game just fell into
                place.<br />
                I had the task of making the modules and player movement. I also worked on the level design and art.<br />
                The other participants loved our game and we got the second most votes for the best game.
            </div>,
        image: "./img/Module Wreck/1.jpeg",
        screenshotPath: "./img/Module Wreck/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1403873?bg_color=d1d1d1&amp;fg_color=222222&amp;link_color=2a15dc&amp;border_color=535353" width="552" height="167"><a href="https://zeyt8.itch.io/module-wreck">Module Wreck by Zeyt8, TheDarkVoice</a></iframe>,
    },
    {
        title: "Jocul cu Urși",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam Next 2019</b><br />
                <b>About the Game</b><br />
			    Jocul cu Urși ("The Game with Bears") is a comically bad game where you play as an unnamed superhero.<br />
			    You must use the only super power you have, lifting things up at the cost of making a lot of noise to reach the end of the level.<br />
                <b>Development</b><br />
                This project was part of the event "Global Game Jam Next 2019". It was a smaller scale jam. It was 5 days
                long but we only worked during the day, from 10 to 16. I was one of the 2 programmers and I also worked on
                the sprites.<br />
                We were 4 people in the team, but we found ourselves with no artist. Because of that we decided to make a
                game that is comically bad.<br />
                We tailored the experience to be as badly made as posible, but on purpose, from the assets to the sound
                design, and even how the code works.<br />
                At the end of the event we held a presentation of our game and I can say that our objective was fullfilled.<br />
                The audience was in tears from laughing when we were playing the game and we got praise saying that we
                nailed making a game that is bad on purpose.
            </div>,
        image: "./img/Jocul cu Ursi/1.jpeg",
        screenshotPath: "./img/Jocul cu Ursi/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1412392?bg_color=20ffc1&amp;fg_color=222222&amp;link_color=fa5c5c&amp;border_color=35b894" width="552" height="167"><a href="https://zeyt8.itch.io/jocul-cuursi">Jocul cu Ursi by Zeyt8, TheDarkVoice</a></iframe>,
    },
    {
        title: "NEET Rush",
        tags: ["Unity"],
        description:
            <div>
                <b>Global Game Jam 2019</b><br />
                <b>About the Game</b><br />
                You find yourself in the shoes of a social outcast, a man who sits all his day in front of the computer. All of
                a sudden it breaks.<br />
                You have to bring the PC to the repaird shop while avoiding people. If you stay close to them too much your
                anxiety will increase and you will return home. Fortunatelly there are bushes that you can hide into.<br />
                Try to bring your PC to repair to save your HOME.<br />
                <b>Development</b><br />
                This project was part of the event "Global Game Jam 2019". The theme was "HOME". Our idea was that our
                character that stays in front of his computer all day, basically considers that his home.<br />
                It was the first time I participated in a game jam. To make things easy we decided to go for a 2D
                sidescroller. My first game jam was an eye opening experience for me and I gained a taste on what
                programming a game feels like.<br />
                In the night before the last day of the event we relised that even though the code was written we did no t
                have the art ready. Fortunately for us, there was another team full of artists that were missing a
                programmer, because he left the event.<br />
                We made a deal. 2 of them made art for us, while I coded their game. In that night I rewrote their entire
                game into Unity, as I was unfamiliar with their home made engine.
                In the end both projects were finished on time.
            </div>,
        image: "./img/NEET Rush/1.jpeg",
        screenshotPath: "./img/NEET Rush/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1404209" width="552" height="167"><a href="https://zeyt8.itch.io/neet-rush">NEET Rush by Zeyt8, TheDarkVoice</a></iframe>,
    }
];

const OTHER_PROJECTS = [
    {
        title: "Surge of the Legion",
        tags: ["Unity", "DOTS"],
        description:
            <div>
                <b>About the Game</b><br />
                This game is more on the simulation side, than the game one. The goal was to be able to simulate the movement of at least 5000 units.<br />
                To achieve this goal we have used the DOTS framework from Unity. I implemented most of the gameplay features, and general game architecture. It has been a very good experience to learn how ECS works.<br />
                To solve the animation performance issues, and Unity's lack of support for skinned meshes in DOTS, I have implemented a custom vertex animator. I am baking frames from the character animations and interpolating between them in a vertex shader.
                <b>Development</b><br />
            </div>,
        image: "./img/Surge of the Legion/1.jpeg",
        screenshotPath: "./img/Surge of the Legion/",
    },
    {
        title: "Cue Clash",
        tags: ["Unity", "Online PvP"],
        description:
            <div>
                <b>About the Game</b><br />
                A fun twist on the 8ball pool game. Inspired by chess-boxing, players take turns between pool rounds and dueling rounds.<br />
                Sinking balls gives you ammo for the dueling round. Each ball has different stats.<br />
                Players can duel using their cue as a sword, by striking, slashing and parrying. They can also use it as a gun to shoot the gained ammo.<br />
                Whoever deals the most damage wins the duel. Damage is permanent and inflicts debuffs on the player.<br />
                The winner is the first to strike in the next pool phase.<br />
                Reaching the conventional pool win condition and then winning the next dueling rounds crowns you the winner.<br />
                <b>Development</b><br />
                I made this game together with some classmates as a project for our Software Engineering class. The purpose of the project was to learn how to do design documents, project management and Agile development.<br />
                I was the only one with more than basic experience in game development, so naturally I was the project manager. I came up with tasks for everyone and descriptions for what needed to be done.<br />
                I also made sure everyone was on track and helped them with any problems they had. I did merge reviews and integrated their work into the project.<br />
                Programming wise, I did everything related to networking, the lobby, connections and synchronizing the game state between players. This was my first completed project using UGS.<br />
                I also worked on the melee combat with another teammate.<br />
                Most of the animations are procedural. Things related to animations, lights, shaders and the scene itself were done by me aswell and it has been a great learning experience.
            </div>,
        image: "./img/Cue Clash/4.jpeg",
        screenshotPath: "./img/Cue Clash/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/2116748?bg_color=5AE689&amp;fg_color=222222&amp;link_color=222222&amp;border_color=c78b5f" width="552" height="167"><a href="https://zeyt8.itch.io/cue-clash">Cue Clash by Zeyt8, zsradu</a></iframe>,
    },
    {
        title: "Chess++",
        tags: ["UE4"],
        description:
            <div>
                <b>About the Game</b><br />
                The game is a variation of 3 man chess. Unlike the normal variant, you have more pieces and attacks don't
                instantly destroy enemy pieces.<br />
                Your army is the classic 16 pieces, 2 row configuration. You can choose any of the available pieces to add as
                long as your total score is low enough.<br />
                Units don't instantly take enemy pieces. Pieces have health and they dissapear when their health reaches 0. Most
                new pieces have abilities that interact with the new mechanics.<br />
                The first player that manages to destroy any king wins the game.<br />
                <b>Development</b><br />
                This project was made as my first Unreal Engine 4 project. I worked solo on it to learn the engine and
                deepen my c++ coding skills. It is mainly coded in c++. It took about 2 weeks to make.<br />
                From this project I have accustomed myself with the Unreal Engine 4 workflow. I gained knowledge in how to
                make a saving system, parse player input, work with multiple coordinates systems.<br />
                The game is not 100% finished, but it is playable with the default pieces.
            </div>,
        image: "./img/Chess++/1.jpeg",
        screenshotPath: "./img/Chess++/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1505339" width="552" height="167"><a href="https://zeyt8.itch.io/chess">Chess++ by Zeyt8</a></iframe>,
    },
    {
        title: "Techtonic",
        tags: ["Unity", "LAN Co-op"],
        description:
            <div>
                <b>About the Game</b><br />
                The game is a 3D 2-player LAN co-op puzzle/shooter where 2 players take control of a father and a drone that try
                to escape the underground they are in.<br />
                The action takes place in an underground steampunk city. Suddenly the earth shakes, you pick up your weapon and
                together with your drone you go explore to see what happened.<br />
                The place is swarming with hostile soldiers and you need to fight them while solving puzzles to progress through
                the level. Most things you do require cooperation.<br />
                The father deals the damage, but the drone is small and can reach remote places. All your abilities interact
                with the enviroment, so don't hesitate to try. At last, your abilities also pair up to make unique effects.<br />
                At the end of the cave, right before you make your exit, you are greeted by a big robot. Let the boss fight begin!<br />
                <b>Development</b><br />
                The project was made for Gameccelerator 2019, a competition for an internship at Ubisoft Bucharest. I worked
                as the sole programmer.<br />
                I expanded my programming skills vastly while I was working on this project. I learned how to do networking
                using Unity HLAPI, syncronizing 2 players on LAN, their interaction with each other and various AI enemies.<br />
                I worked close to the artist in programming IKs for our characters and I made research on rotations and
                quaternions.<br />
                The development took place for 4 months, full of work. I gained experience in building a 3d game, using
                networking APIs, IKs and making cinematics.<br />
                <b>Mechanics</b><br />
                <ul>
                    <li>The drone has an ability that pushes all things around it. This can be used to push the other player to
                higher places.</li>
                    <li>The drone's harpoon has an eletrical charge. With it the drone can power up generators and control the
                rail switch.</li>
                    <li>The father's jump can break certain objects if he has enough velocity on impact. Velocity can be aquired
                by falling from high places.</li>
                    <li>The father's grenade, if it detonates near the drone's harpoon has an area of effect discharge that powers
                up nearby electrical devices.</li>
                    <li>The vents are blocked by steam pipes and the father needs to switch them in order to help the drone pass.</li>
                    <li>The boss fight can only be won through cooperation. The boss gets staggered after a certain amount of
                hits. Then the players need to do 1 of the 2 combos. They can either use the grenade electrical discharge or
                get the father to a high places from where to fall upon the boss.</li>
                </ul>
            </div>,
        image: "./img/Techtonic/3.jpeg",
        screenshotPath: "./img/Techtonic/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/993873" width="552" height="167"><a href="https://zeyt8.itch.io/techtonic">Techtonic by Zeyt8</a></iframe>,
    },
    {
        title: "Attack on Bastille",
        tags: ["Unity"],
        description:
            <div>
                <b>About the Game</b><br />
                The revolutionaries are mad at the king and they are coming to take down The Bastille.<br />
                You can hire royal troops or mercenaries to stomp on the revolt. Royal troops will drain your manpower, while
                mercenaries only cost you coins.<br />
                You have an arsenal of 3 types of units. Marksmen which stay on the roofs, swordmen which fight on the streets
                and barricades.<br />
                Last as long as you can. The revolution cannot be stopped, only delayed.<br />
                <b>Development</b><br />
                I made this project together with a friend for our french class. It took us 2 days to see it completed. I
                was in charge of the programming and design and he did the models and animations.<br />
                It was a lot of fun researching the streets of Paris to find a good map design. The programming part went
                smoothly and I am proud of how good the game feels after only investing 2 days into it.<br />
                From this game I found that a simple, but focused design can easily make a fun game. From time to time I
                come back to play it and I enjoy it every time.
            </div>,
        image: "./img/Attack on Bastille/1.jpeg",
        screenshotPath: "./img/Attack on Bastille/",
        widget: <iframe frameborder="0" src="https://itch.io/embed/1418624" width="552" height="167"><a href="https://zeyt8.itch.io/attack-on-bastille">Attack on Bastille by Zeyt8</a></iframe>,
    }
];

const TOOLS = [
    {
        title: "Visual Graph Scripting (v2)",
        tags: ["Unity"],
        description:
            <div>
                <b>About</b><br/>
                General framework to create visual graph scripting tools that are automatically converted to runtime data. The editor frontend uses the Unity GraphToolkit API. The framework is structured to allow users to easily create their own nodes on top of the already existing ones.
                <br/>
                The framework includes commonly used nodes and can be used as is, for general scripting graphs, or specialized for other tools. I have created another package using it for scripting dialogue trees.
                <br/>
                <b>Features</b><br/>
                General Graph Scripting<br/>
                <div className={classes.imageContainer}>
                    <img className={classes.image} src="./img/VisualGraphs/1.jpeg" />
                </div>
                Full Variable Support, Including Scene References<br/>
                <div className={classes.imageContainer}>
                    <img className={classes.image} src="./img/VisualGraphs/2.jpeg" />
                    <img className={classes.image} src="./img/VisualGraphs/6.jpeg" />
                    <img className={classes.image} src="./img/VisualGraphs/3.jpeg" />
                </div>
                Fully Generic Nodes<br/>
                <div className={classes.imageContainer}>
                    <img className={classes.image} src="./img/VisualGraphs/4.jpeg" />
                    <img className={classes.image} src="./img/VisualGraphs/5.jpeg" />
                </div>
                Dialogue Tree Graph with Full Scripting Support<br/>
                <div className={classes.imageContainer}>
                    <img className={classes.image} src="./img/VisualGraphs/7.jpeg" />
                </div>
            </div>,
        image: "./img/VisualGraphs/1.jpeg"
    },
    {
        title: "Level Scripting",
        tags: ["Unity"],
        description:
            <div>
                Visual graph level scripting tools.<br />
                Current features:<br />
                <ul>
                    <li>Basic dialogue system with an exposed dialogue view interface</li>
                    <li>Scene references to be used in the scripting</li>
                    <li>Support for creating custom nodes</li>
                    <li>Global game events</li>
                </ul>
                Planned features:<br />
                <ul>
                    <li>Rework game events to use scriptable objects</li>
                    <li>Add a blackboard with variables</li>
                </ul>
            </div>,
        image: "./img/LevelScripting/1.jpeg",
        screenshotPath: "./img/LevelScripting/",
        widget: <a href="https://github.com/Ivories-Studios/Level-Scripting" target="_blank" rel="noopener noreferrer">
            <button className={classes.button}>Go to GitHub Repo</button>
        </a>
    },
    {
        title: "Stlylized Rendering",
        tags: ["Unity"],
        description:
            <div>
                Stylized rendering using Unity SRP and the new Render Graph API. Features:<br />
                <ul>
                    <li>
                        Screen space outlines based on Robert's Cross with different properties based on the edge type
                        <ul>
                            <li>Depth differences: normal outlines</li>
                            <li>Normal differences: thinner outlines</li>
                            <li>Color differences: dotted outlines</li>
                        </ul>
                    </li>
                    <li>
                        Custom shader for lighting that works with a directional light and multiple point and spot lights.
                        <ul>
                            <li>Cel shading, creating a color banding effect</li>
                            <li>Shadows are drawn as a stippling effect. The strength of the shadow is represented by the density of the noise.</li>
                            <li>Transparency is simulated as a dithering effect with a half-tone pattern.</li>
                            <li>Volumetric lights are created by extracting a mask of the skybox and applying a radial blur on it, then decreasing the light intensity over the distance of the rays.</li>
                        </ul>
                    </li>
                    <li>Bloom post-processing created with a grid texture in areas of high luminosity, that slowly rotates. I am using mutiple passes of a Gaussian Blur before sampling the luminosity.</li>
                </ul>
            </div>,
        image: "./img/StylizedRendering/1.jpeg",
        screenshotPath: "./img/StylizedRendering/",
    }
]

const HARDWARE = [
    {
        title: "Amorfos Console & Framework",
        tags: ["Arduino"],
        description:
            <div>
                This is a console I made as a project for university. It has a joystick and 4 buttons as input and an LCD, a buzzer and 2 LEDs for output.<br />
                In the repo you can find a framework I made to make games for this console and hardware specifications of the console. Games are compiled using Arduino IDE.<br />
                The framework uses C++, but since the console isn't very powerful, it doesn't use classes. Instead it uses structs and functions, like in C.<br />
                Game examples and a template for starting a new project can be found in the repo as well.
            </div>,
        image: "./img/Amorfos Console/amorfos-finished.jpeg",
        screenshotPath: "./img/Amorfos Console/",
        widget: <a href="https://github.com/Zeyt8/Amorfos-Console" target="_blank" rel="noopener noreferrer">
            <button className={classes.button}>Go to GitHub Repo</button>
        </a>
    }
];

const ART = [
    {
        title: "Electrodwarfs",
        tags: ["Unity"],
        description:
            <div>
                Some models, animations, and VFX I made for a game that I stopped working on.
            </div>,
        image: "./img/Electrodwarfs/BasicDwarf.jpeg",
        screenshotPath: "./img/Electrodwarfs/",
    },
    {
        title: "Olaf's Promise",
        tags: ["UE5"],
        description: 
            <div>
                A short movie done for the Computer Animation class.<br />
                Animations have been done using the Vicon Motion Capture system and retargeted for UE Metahumans. Facial animations have been done using an IPhone and LiveLink.<br />
                The final animations have been assembled and rendered in UE5.
            </div>,
        image: "./img/OlafsPromise/1.jpeg",
        screenshotPath: "./img/OlafsPromise/",
        ytLink: <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/SXQy7OY2Awg?si=qZl2cDkiklyHvhbX" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>,
    }
];

export { RELEASED_GAMES, LONG_PROJECTS, GAME_JAMS, OTHER_PROJECTS, TOOLS, HARDWARE, ART };